export const LIBRARY_TYPES = {
  stripeElement: 'stripeElement',
  stripeJs: 'stripeJs',
};
